import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  DeviceProfile,
} from "../../model/model";

import DeviceProfileForm from "./DeviceProfileForm";
import SessionStore from "../../model/SessionStore";
import DeleteConfirm from "../../components/DeleteConfirm";
import { Button, Space, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

function EditDeviceProfile() {
  const navigate = useNavigate();
  const { devProfileId } = useParams();
  const [deviceProfile, setDeviceProfile] = useState<DeviceProfile | undefined>(undefined);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const loadDeviceProfile = () => {
      SessionStore.getClient().getDeviceProfile(devProfileId!, SessionStore.getBearer()).then((resp) => {
        setDeviceProfile(resp.data);
      });
    };
    loadDeviceProfile();
    return () => {
    };
  }, [devProfileId]);

  const onFinish = (obj: DeviceProfile) => {
    SessionStore.getClient().updateDeviceProfile(obj, SessionStore.getBearer()).then(() => {
      navigate(`/device-profiles`);
    });
  };

  const deleteDeviceProfile = () => {
    if (!deviceProfile) return;
    SessionStore.getClient().removeDeviceProfile(deviceProfile.id, SessionStore.getBearer()).then(() => {
      messageApi.success("Device profile deleted");
      navigate(`/device-profiles`);
    }).catch(err => {
      if (err.status === 401) {
        navigate(`/login`);
      } else {
        messageApi.open({
          type: 'error',
          content: err.message,
        });
      }
    });
  };

  if (deviceProfile === undefined) {
    return null;
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      {contextHolder}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <DeleteConfirm confirm={deviceProfile.name} typ="device profile" onConfirm={deleteDeviceProfile}>
          <Button danger icon={<DeleteOutlined />}>
            Delete device profile
          </Button>
        </DeleteConfirm>
      </div>
      <DeviceProfileForm initialValues={deviceProfile!} onFinish={onFinish}  update/>
    </Space>
  );
}

export default EditDeviceProfile;
